/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { useBrand } from '@/lib/whitelabel';
import { THEME_CONFIG } from '@/config/themeConfig';
import { LogoMark } from '@/components/brand/LogoMark';
import { splitBrandName } from '@/components/brand/brandName';

/**
 * Brand Logo — dynamic mark + two-tone wordmark for both SaaS and White-Label
 * deployments. Colors come from BrandProvider with THEME_CONFIG fallbacks.
 */
export const Logo = ({ size = 44, className = '', withText = true, textClassName = '', tagline = null }) => {
  const brand = useBrand();
  const name = brand.clinicName || THEME_CONFIG.appName;
  const [prefix, suffix] = splitBrandName(name);

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <LogoMark
        size={size}
        name={name}
        logoUrl={brand.logoUrl}
        primary={brand.primaryColor || THEME_CONFIG.colors.primary}
        primaryAlt={brand.primaryColorAlt || THEME_CONFIG.colors.secondary}
        accent={brand.accentColor || THEME_CONFIG.colors.accent}
      />
      {withText && (
        <div className={`leading-tight ${textClassName}`}>
          <div className="font-display font-bold tracking-tight text-[1.15em] flex items-baseline gap-0.5">
            <span className="text-foreground">{prefix}</span>
            {suffix && suffix !== prefix && <span className="text-primary">{suffix}</span>}
          </div>
          {tagline && <div className="text-[9.5px] sm:text-[10.5px] text-muted-foreground uppercase tracking-wide leading-tight max-w-[60vw] sm:max-w-none" data-testid="brand-tagline">{tagline}</div>}
        </div>
      )}
    </div>
  );
};

export default Logo;
